import { DialogTitle, styled } from '@mui/material';

export const CustomDialogTitle = styled(DialogTitle)({
  padding: '0.75rem 1.5rem 0',
});
